import { gql } from '@apollo/client';

export const VERIFICATION_STATUS_QUERY = gql`
  query {
    kycIdentity {
      verificationStatus
      personalInformation {
        netWorth
        netWorthValue
        annualIncome
        annualIncomeValue
        isAccredited
        howWillYouFund
        adventurousType
      }
      kycConnections {
        kycProcessor
        verificationStatus
        comment
        dateSuspended
      }
    }
  }
`;
